import styled, { css } from 'styled-components';

import { size } from '../../layout/helpers';
import type { BadgeToneProps } from './index';

interface WrapperProps {
  $tone?: BadgeToneProps;
  $size?: 'small';
  $noWrap?: boolean;
  $bleedBlock?: boolean;
  $cursor?: HTMLDivElement['style']['cursor'];
  $gap?: string;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}

export const Wrapper = styled.div<WrapperProps>`
  --badge-bg: var(--c-accent-bg);
  --badge-fg: var(--c-accent-fg);
  --badge-padding-block: ${size(0.5)};

  display: flex;
  align-items: center;
  gap: ${size(0.5)};
  width: max-content;
  min-width: max-content;
  padding: var(--badge-padding-block) ${size(1)};
  background-color: var(--badge-bg);
  color: var(--badge-fg);
  border-radius: ${size(0.5)};
  font-weight: var(--font-weight-bold);
  font-size: ${(props) => props.theme.font.size.xsmall};
  line-height: ${(props) => props.theme.font.lineHeight.alt};

  ${({ $cursor }) =>
    $cursor &&
    css`
      cursor: ${$cursor};
    `}

  ${({ $gap }) =>
    $gap &&
    css`
      gap: ${$gap};
    `}

  ${({ $tone }) =>
    $tone === 'success'
      ? css`
          --badge-bg: var(--c-semantic-success-300);
          --badge-fg: var(--c-semantic-success-700);
        `
      : $tone === 'error'
        ? css`
            --badge-bg: var(--c-semantic-error-300);
            --badge-fg: var(--c-semantic-error-700);
          `
        : $tone === 'warning'
          ? css`
              --badge-bg: var(--c-semantic-warning-300);
              --badge-fg: var(--c-semantic-warning-700);
            `
          : $tone === 'info'
            ? css`
                --badge-bg: var(--c-semantic-info-300);
                --badge-fg: var(--c-semantic-info-700);
              `
            : $tone === 'disabled'
              ? css`
                  --badge-bg: var(--c-semantic-neutral-300);
                  --badge-fg: var(--c-semantic-neutral-700);
                `
              : $tone === 'ghost'
                ? css`
                    --badge-bg: transparent;
                    --badge-fg: var(--c-semantic-neutral-500);

                    border: 1px solid var(--c-border-main);
                    font-weight: var(--font-weight-regular);
                  `
                : $tone === 'contrast'
                  ? css`
                      --badge-bg: var(--c-contrast-bg);
                      --badge-fg: var(--c-contrast-fg);
                    `
                  : undefined}

  ${({ $size }) =>
    $size === 'small'
      ? css`
          padding: ${size(0.25)} ${size(0.75)};
          font-size: ${(props) => props.theme.font.size.xxsmall};
          text-transform: uppercase;
        `
      : undefined}

  ${({ $noWrap }) =>
    $noWrap &&
    css`
      white-space: nowrap;
    `}

    ${({ onClick }) =>
      onClick &&
      css`
      cursor: pointer;
    `}

  ${({ $bleedBlock }) =>
    $bleedBlock &&
    css`
      --badge-bleed-block: calc(var(--badge-padding-block) * -1);

      margin-top: var(--badge-bleed-block);
      margin-bottom: var(--badge-bleed-block);
    `}
`;
